
/**
 * エラーメッセージのメッセージID生成
 * @param errorCode エラーコード
 * @returns メッセージID
 */
export function getErrorMsgId(errorCode: string): string {
    return `request.comm.error.${errorCode}`;    
}
